/*
 * @Description: '登录'页面所有请求
 */

import * as http from './base'

/**
 * 获取当前账户
 * @param {object} data
 */
export const getSimple = (data) => {
    return http.fetch(http.url.user + '/account/default/simple', data, { certificate: true })
}

/**
 * 查询名下所有子账户列表
 * @param {object} data
 */
export const getAccounts = (data) => {
    return http.fetch(http.url.user + '/account/accountlist', data, { certificate: true })
}

/**
 * 查询币种配置
 * @param {object} data
 */
export const getPoolCoin = (data) => {
    return http.fetch(http.url.user + '/coin/poolCoins', data, { certificate: true })
}

/**
 * 查询币种对应网络
 * @param {object} data
 */
export const getChainType = (data) => {
    return http.fetch(http.url.user + '/coin/poolCoins/chainTypes', data, { certificate: true })
}


/**
 * 新增或修改子账户信息
 * @param {object} data
 */
export const addAccount = (data) => {
    return http.post(http.url.user + '/account/save', data, { certificate: true, json: true })
}

/**
 * 获取转账钱包列表
 * @param {object} data
 */
export const getAssigns = (data) => {
    return http.fetch(http.url.user + '/account/assign', data, { certificate: true })
}

/**
 * 设置指定的子账户为激活状态
 * @param {object} data
 */
export const setActive = (data) => {
    return http.fetch(http.url.user + '/account/active', data, { certificate: true })
}

/**
 * 获取用户余额
 * @param {object} data
 */
export const getBalance = (data) => {
    return http.fetch(http.url.user + '/account/coinBalance', data, { certificate: true })
}

/**
 * 获取充值地址信息
 * @param {object} data
 */
export const getRechargeAddr = (data) => {
    return http.fetch(http.url.user + '/account/rechargeAddress', data, { certificate: true })
}

/**
 * 查询用户支出资金流水
 * @param {object} data
 */
export const getOutCashFlow = (data) => {
    return http.post(http.url.user + '/account/outCashFlow', data, { certificate: true, json: true })
}

/**
 * 查询用户充值资金流水
 * @param {object} data
 */
export const getRechargeCashFlow = (data) => {
    return http.post(http.url.user + '/account/rechargeCashFlow', data, { certificate: true, json: true })
}

/**
 * 获取导航栏筛选币种
 * @param {object} data
 */
export const getNavPoolCoins = (data) => {
    return http.fetch(http.url.user + '/coin/nav/poolCoins', data, { certificate: true, json: true })
}


/**
 * 获取用户下拉币种
 * @param {object} data
 */
export const getUserCoins = (data) => {
    return http.fetch(http.url.user + '/coin/user/coins', data, { certificate: true, json: true })
}


// WEBPACK FOOTER //
// ./src/http/account.js